import { render } from "./input_free_text.vue?vue&type=template&id=08704be0&scoped=true"
import script from "./input_free_text.vue?vue&type=script&lang=js"
export * from "./input_free_text.vue?vue&type=script&lang=js"

import "./input_free_text.vue?vue&type=style&index=0&id=08704be0&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08704be0"]])

export default __exports__